import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from '../../store/hooks/useSelector'
import { Link, Navigate, useNavigate } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Page, PageLoadingSpinner } from 'ui_kit_qmd'
import { LOGOUT } from '../../store/auth/AuthConstants'
import { HOME_PAGE_PATH } from '../../utils/constants'
import { changeTabs } from '../../store/accountSettings/AccountSettingsActions'
import './ProviderPage.scss'

export const ProviderPage = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  contentContainerStyle,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  render,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  showSide,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  active,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  crumbs,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  loading,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  pageContainerStyle,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sidePanelContainer,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sideWithoutRedirect,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setActiveTab,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setIsConfirmationPopUpOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onCollapsedCallback,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sideBarRef,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isLoginPage,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  reloadSection,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  breadCrumbsCallBack,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isLoggedIn = useSelector((state) => state.auth.accessToken)
  const providerProfile = useSelector((state) => state.waitingRoomReducer.providerProfile)

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(changeTabs('Account'))
    }
  }, [dispatch, isLoggedIn])

  const onLogout = () => {
    // ui_kit_qmd's SidePanel (SidePanel.js:184-189) calls this from a useEffect whenever
    // `isLoggedIn` goes falsy — i.e. AFTER a logout has already happened — using the same
    // callback as a genuine click at :196. Re-dispatching there mislabels the Sentry reason
    // as 'manual' and, because 'manual' is a CROSS_TAB_LOGOUT_REASON, re-broadcasts a
    // deliberately tab-local logout to every other tab, including one holding a live visit.
    // ui_kit_qmd is frozen, so the guard belongs here.
    if (!isLoggedIn) return
    dispatch({ type: LOGOUT, reason: 'manual' })
  }

  if (!isLoginPage && !isLoggedIn) {
    navigate(HOME_PAGE_PATH)
  }

  return (
    <Page
      contentContainerStyle={contentContainerStyle}
      setIsConfirmationPopUpOpened={setIsConfirmationPopUpOpened}
      sideWithoutRedirect={sideWithoutRedirect}
      setActiveTab={setActiveTab}
      render={render}
      showSide={showSide}
      active={active}
      crumbs={crumbs}
      crumbsCallBack={breadCrumbsCallBack}
      loading={loading}
      // `role` is a ui_kit_qmd Page prop (Provider vs Patient mode), not an ARIA role.
      // eslint-disable-next-line jsx-a11y/aria-role
      role='Provider'
      pageContainerStyle={pageContainerStyle}
      sidePanelContainer={sidePanelContainer}
      isLoggedIn={isLoggedIn}
      profileData={providerProfile}
      onLogout={onLogout}
      loadingSpinner={<PageLoadingSpinner />}
      LinkComponent={Link}
      NavigateComponent={Navigate}
      onCollapsedCallback={onCollapsedCallback}
      sideBarRef={sideBarRef}
      reloadSection={reloadSection}
    />
  )
}
